<template>
  <div id="app">
    <div class="wrapper" :class="djsTime > 0 ? 'wrapper_pdt2' : 'wrapper_pdt1'">
<!--      <OpenHsjApp mark="shareCourse" />-->
      <img class="top-bar" src="./img/bar.png" alt="">
      <div class="course-details">
        <div class="top">
          <h1 class="van-multi-ellipsis--l2">{{ form.name }}</h1>
<!--          <div class="course-info van-ellipsis">-->
<!--            <template v-if="form.knowledgeCount"-->
<!--              >课程数{{ form.knowledgeCount }}</template-->
<!--            >-->
<!--            <template v-else>试卷数{{ form.testPaperCount }}</template>-->
<!--            <span class="line"></span>-->
<!--            {{ form.learnCount || 0 }}人已学-->
<!--            <span class="line"></span>-->
<!--            <template v-if="form.countDownFlag">-->
<!--              <VanCountDown-->
<!--                style="display: inline-block"-->
<!--                @finish="getCourseOnly()"-->
<!--                format="HH时mm分ss秒"-->
<!--                :time="form.effectiveMillis"-->
<!--              />-->
<!--              {{ form.effectiveDaysDesc }}-->
<!--            </template>-->
<!--            <template v-else>-->
<!--              {{ form.effectiveDaysDesc }}-->
<!--            </template>-->
<!--          </div>-->
        </div>
        <div class="content rich-text ql-editor">
          <div v-html="form.operateCourseContent"></div>
        </div>
      </div>
    </div>
    <div class="bottom-wrap">
      <HsjCountDown
        ref="hsjCountDownRef"
        v-if="djsTime > 0"
        :time="djsTime"
        :labelName="labelName"
        :timeLimit="form.timeLimit"
        @getTime="getCountDownTime"
        @finish="getCourseOnly()"
      />
<!--      <AngleVipDown-->
<!--        v-if="isAngleVip"-->
<!--        :isLogin="userInfo ? true : false"-->
<!--        from="shareCourse"-->
<!--      />-->
      <div class="group-btns">
<!--        <Button class="btn-item btn-customer" @click="openService">课程咨询</Button>-->
        <Appointment
            ref="AppointmentRef"
            :isLogin="userInfo ? true : false"
            @login="getWxCodeLogin(true)"
            @ok="update()"
            :form="form"
            v-if="form.courseButtonType == 10||
          form.courseButtonType == 11||form.courseButtonType == 12
          ||form.courseButtonType == 13||form.courseButtonType == 14"
        />

        <template v-if="hasCourseAuth">
          <div
              @click="downloadHsjApp"
              class="btn-item  s-vip"
          >
            <span class="s-vip-t">去学习</span>
            <span class="s-vip-tip">会员可免费学习本节课程</span>
          </div>
        </template>
        <Button
          v-else-if="form.courseButtonType == 7"
          class="btn-item btn-subscribe"
          @click="downloadHsjApp"
          >去App学习</Button
        >

        <Button
          v-else-if="form.courseButtonType == 2"
          @click="subscribe(7)"
          class="btn-item btn-subscribe"
        >
          免费学习
        </Button>
        <Button
          v-else-if="form.courseButtonType == 3"
          @click="subscribe(7)"
          class="btn-item btn-subscribe"
        >
          限时免费
        </Button>
        <template
            v-else-if="
          form.courseButtonType == 1 ||
          form.courseButtonType == 4 ||
          form.courseButtonType == 5 ||
          form.courseButtonType == 6
        "
        >
          <SVipBtn
              v-if="isSVipCourse"
              :form="form"
              :isLogin="!!userInfo"
              @h5VipBuy="h5VipBuy()"
              @buy="has=>buyCourse(has)"
          />
          <Coupon
              v-else
              ref="CouponRef"
              :isLogin="!!userInfo"
              :form="form"
              :labelName="labelName"
              @buy="has=>buyCourse(has)"
          />
        </template>
      </div>
    </div>
    <img
      v-if="h5Audition"
      @click="clickH5Audition"
      class="h5-audition scale-animation"
      :class="djsTime > 0 ? 'h5-audition-bottom' : ''"
      src="./img/btn.png"
      alt=""
    />
    <H5LoginPopup ref="H5LoginPopupRef" @loginSuccess="loginSuccess"/>
    <ZN10Popup v-if="userInfo"/>
  </div>
</template>
<script>
import {Button, Toast, CountDown as VanCountDown} from "vant";
// import OpenHsjApp from "@/components/OpenHsjApp/OpenHsjApp.vue";
import HsjCountDown from "@/components/CourseDetail/CountDown.vue";
import { isWechat, isClient } from "@/utils/isTerminal.js";
import {subscibe, loginWx, shortUrl, shortParams} from "@/api/shareH5.js";
import { wechatSignature } from "@/utils/weixin.js";
import {delCurrentUrlParam, wechatShareConfig} from "@/utils/index.js";
import Config from "@/config/app.js";
import callApp from "@/config/callApp.js";
import {
  hsjH5BurialPoint,
  activityH5BurialPoint
} from "@/utils/shareCommon.js";
import { getCurrentUrl } from "@/utils/app.js";
import {getH5CourseIntroduce, receiveCourseCoupon} from "@/api/coursePack.js";
import { obj2StrParams } from "@/utils/index";
// import AngleVipDown from "@/components/CourseDetail/AngleVipDown.vue";
import Appointment from "@/pages/courseDetails/component/Appointment.vue";
import H5LoginPopup from "@/components/H5LoginPopup/H5LoginPopup.vue";
import {getAngelVipUserBaseInfoAll} from "@/api/angelVipInfo";
import Coupon from "@/pages/courseDetails/component/Coupon.vue";
import SVipBtn from "@/pages/courseDetails/component/SVipBtn.vue";
import {set} from "loadsh/object";
import ZN10Popup from "@/pages/courseDetails/component/ZN10/ZN10Popup.vue";

export default {
  name: "app",
  data: function() {
    return {
      form: {},
      userInfo: JSON.parse(sessionStorage.getItem("userNurseLoginInfo")),
      h5Audition: false, //针对特定课程是否显示试听活动
      djsTime: 0,
      labelName: "",
      hasCourseAuth:false,//通过会员对应的课程会员判断是否有权限
      isVipCourse: 0 //当前课程是否是vip课程
    };
  },
  methods: {
    loginSuccess(user){
      this.userInfo = user
      let ref = this.$refs.AppointmentRef
      if(PAGE_PARAMS.appointment==1 && ref ){ref.clickBtn()}
    },
    downloadHsjApp() {
      hsjH5BurialPoint("B000026", "B000026-006", { id: PAGE_PARAMS.courseId });
      if (this.form.useFlag == 0) {
        Toast("该课程已下架");
        return;
      }
      setTimeout(() => {
        window.location.href = callApp.yingyongbao;
      }, 500);
    },
    h5VipBuy(){
      if (!this.userInfo) {
        this.getWxCodeLogin();
        return;
      }
      shortParams(this.userInfo)
          .then(r => {
            window.location.href = `${Config.activeShareCourse}/hsjH5Login.html?res-key=${r}`;
          })
          .catch(_ => {});
    },
    openService() {
      hsjH5BurialPoint("B000026", "B000026-001", { id: PAGE_PARAMS.courseId });
      setTimeout(() => {
        window.location.href = "https://work.weixin.qq.com/kfid/kfcfb26ee166a623add"
      }, 500);
    },
    buyCourse(hasCourseCoupon = false) {
      if (!this.userInfo) {
        this.getWxCodeLogin();
        return;
      }
      hsjH5BurialPoint("B000026", "B000026-002", { id: PAGE_PARAMS.courseId });
      //和白羽沟通去掉了B000008-001埋点。
      //hsjH5BurialPoint('B000008', 'B000008-001', {id: PAGE_PARAMS.courseId, name: this.form.name});
      if (this.form.useFlag == 0) {
        Toast("该课程已下架");
        return;
      }
      if (hasCourseCoupon) {
        receiveCourseCoupon(this.courseId).then(() => {
          this.goSettlement()
        }).catch(() => {
          this.goSettlement()
        })
      } else {
        this.goSettlement()
      }
    },
    goSettlement(){
      setTimeout(() => {
        window.location.href = `./shareCourseSettle.html${obj2StrParams(
            window.PAGE_PARAMS
        )}&isVipCourse=${this.isVipCourse ? "1" : "0"}`;
      }, 500);
    },
    subscribe(val) {
      // 未登陆去登陆页面
      if (!this.userInfo) {
        this.getWxCodeLogin();
        return;
      }
      if (this.form.useFlag == 0) {
        Toast("该课程已下架");
        return;
      }
      subscibe({ courseId: PAGE_PARAMS.courseId, subscibeFlag: val, actmk: 1 })
        .then(r => {
          this.form.courseButtonType = 7;
        })
        .catch(_ => {});
      hsjH5BurialPoint("B000026", "B000026-003", { id: PAGE_PARAMS.courseId });
    },
    update(){
      this.getCourseOnly()
    },
    getWxCodeLogin(isAppointment = false) {//isAppointment是否是预约触发的登录
      // 获取code
      let url =  delCurrentUrlParam("code");
      if(isAppointment){
        url += "&appointment=1"
      }
      shortUrl({ url })
        .then(r => {
          window.location.href =
            Config.wxUseUrl + "hsjmp/mp/getCode?shareKey=" + r;
        })
        .catch(_ => {});
    },
    vipCourseAuth(){//处理当前登陆用户是否拥有课程权限，主要是修改 hasCourseAuth 值
      if(!Array.isArray(this.form.vipGroupTypeList)){
        return
      }
      if(this.form.vipGroupTypeList.length === 0){
        return
      }
      if(!this.userInfo){
        return;
      }
      getAngelVipUserBaseInfoAll().then(r=>{
        if(!Array.isArray(r)){
          return
        }
        //遍历用户所拥有的全部会员，当会员状态有效并且此会员类型在课程会员列表中存在，则hasCourseAuth为true
        r.forEach(item=>{
          if(this.form.vipGroupTypeList.includes(item.vipGroupType) && item.userVipStatus === 1){
            this.hasCourseAuth = true
          }
        })
      })
    },
    getCourseOnly(callback = () => {}) {
      // 获取课程
      if (PAGE_PARAMS.courseId) {
        getH5CourseIntroduce({
          courseId: PAGE_PARAMS.courseId,
          openType: isClient ? 1 : 2
        })
          .then(r => {
            if(!r){
              window.location.reload()
              return
            }
            this.form = r;
            this.h5Audition = r.auditionFlag == 1;
            // 保存两位小数
            this.form.finalPriceCNY = r.finalPriceCNY.toFixed(2);
            this.form.sellPriceCNY = r.sellPriceCNY.toFixed(2);
            this.djsTime = r.timeLimitCountDown - 0;
            this.isVipCourse = Boolean(r.isVipCourse);
            if (r.timeLimitCountDown > 0) {
              this.$nextTick(() => {
                  this.djsTime > 0 &&
                  this.$refs.hsjCountDownRef.StartIntertime();
              });
            }
            if (r.discountName && r.discountName != "0") {
              this.labelName = r.discountName;
            }
            if (r.timeLimitFreeFlag == 1) {
              this.labelName = "限时免费";
            }
            callback && callback();
          })
          .catch(() => {});
      }
    },
    getCountDownTime(time) {
      this.djsTime = time;
    },
    getCourseDetails() {
      // 获取课程 + 微信签名
      this.getCourseOnly(() => {
        let courseName = this.form.name;
        let ref = this.$refs.AppointmentRef
        if(PAGE_PARAMS.appointment==1 && ref ){ref.clickBtn()}
        this.vipCourseAuth()
        const {courseId } = window.PAGE_PARAMS ||{}
        hsjH5BurialPoint("B000014x", "B000014x-001", {
          courseId,courseName
        });
        wechatSignature()
          .then(_ => {
            let configs = {
              shareTitle: courseName,
              shareDesc: "这门课程非常合适你，强烈推荐！",
              shareUrl: "http://p.hulian120.com/share/app_share_icon.png"
            };
            wechatShareConfig(configs, () => {});
          })
          .catch(_ => {});
      });
      if (PAGE_PARAMS.courseId && !PAGE_PARAMS.code) {
        setTimeout(() => {
          hsjH5BurialPoint("B000014", "B000014-009", {
            id: PAGE_PARAMS.courseId
          });
        }, 400);
      }
    },
    goLoginPage() {
      this.$refs.H5LoginPopupRef.Show();
    },
    clickH5Audition() {
      activityH5BurialPoint("h5Audition", "STHD001", "STHD001-001", {
        id: PAGE_PARAMS.courseId
      });
      setTimeout(() => {
        shortUrl({
          url:
            getCurrentUrl() +
            "shareCourseAudition.html?courseId=" +
            PAGE_PARAMS.courseId
        })
          .then(r => {
            window.location.href =
              Config.wxUseUrl + "hsjmp/mp/getCode?shareKey=" + r;
          })
          .catch(_ => {});
      }, 400);
    }
  },
  mounted() {
    this.getCourseDetails();
  },
  created() {
    let u = localStorage.getItem("userNurseLoginInfo");
    if(u){
      this.userInfo = JSON.parse(u)
      sessionStorage.setItem("userNurseLoginInfo", u);
    }
    if (isWechat && window.PAGE_PARAMS.code) {
      //保存code本地，如果code被使用过了就不再使用了。
      let localCode = localStorage.getItem("WXAuthCode");
      if (localCode && localCode === window.PAGE_PARAMS.code) {
        return;
      }
      localStorage.setItem("WXAuthCode", window.PAGE_PARAMS.code);
      loginWx({ code: window.PAGE_PARAMS.code, web: 1 })
        .then(r => {

          if (r.loginSuccess) {
            this.userInfo = r.userNurseLoginInfo;
            sessionStorage.setItem(
              "userNurseLoginInfo",
              JSON.stringify(r.userNurseLoginInfo)
            );
            localStorage.setItem("userNurseLoginInfo", JSON.stringify(r.userNurseLoginInfo));
            // Toast("登录成功！")
            this.getCourseDetails();
            setTimeout(() => {
              if(this.$refs.CouponRef){
                this.$refs.CouponRef.clickBtn()
              }
            },600)
          } else {
            this.goLoginPage();
          }
          setTimeout(() => {
            hsjH5BurialPoint("B000026", "B000026-004", {
              id: PAGE_PARAMS.courseId
            });
          }, 300);
        })
        .catch(e => {
          if (e.code == 40163) {
            //刷新带code的页面会授权失败，重新拉取code
            this.getWxCodeLogin();
            return;
          }
          Toast(e.msg);
          setTimeout(() => {
            hsjH5BurialPoint("B000026", "B000026-004", {
              id: PAGE_PARAMS.courseId
            });
          }, 300);
        });
    }
    if(window.PAGE_PARAMS && window.PAGE_PARAMS.autoLoginKey){
      let uStr = localStorage.getItem(window.PAGE_PARAMS.autoLoginKey)
      this.userInfo = JSON.parse(uStr)
      sessionStorage.setItem('userNurseLoginInfo',uStr);
    }
  },
  beforeDestroy: function() {},
  computed: {
    isSVipCourse() {
      let vipList = this.form.vipGroupTypeList
      return Array.isArray(vipList) && vipList.includes(6);
    }
  },
  components: {
    ZN10Popup,
    SVipBtn, Coupon,
    Appointment,
    Button,
    Toast,
    // OpenHsjApp,
    VanCountDown,
    HsjCountDown,
    // AngleVipDown,
    H5LoginPopup
  }
};
</script>
<style lang="scss" scoped>
.wrapper_pdt1 {
  padding-bottom: 45px;
}
.wrapper_pdt2 {
  padding-bottom: 105px;
}
.top-bar{
  width: 100%;
  vertical-align: bottom;
  //border-bottom: 10px solid #F3F5F7;

}
.course-details {
  background: #ffffff;

  .top {
    padding: 0 16px;

    h1 {
      font-size: 24px;
      font-weight: 500;
      color: rgba(34, 34, 34, 1);
      margin: 0;
      line-height: 30px;
    }

    .course-info {
      margin-top: 10px;
      display: flex;
      color: #222;
      align-items: center;
      flex-wrap: wrap;
      font-size: 14px;

      .line {
        width: 1px;
        height: 10px;
        margin: 0 10px;
        background: #222222;
      }
    }
  }

  .content {
    padding: 10px 10px 0 10px;
  }
}

.bottom-wrap {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  .group-btns {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 60px;
    padding: 0 12px;
    box-sizing: border-box;
    background: rgba(255, 255, 255, 1);
    .btn-item {
      display: inline-block;
      //display: inline-flex;
      height: 40px;
      align-items: center;
      justify-content: center;
      border-radius: 20px;
      font-size: 13px;
      font-weight: 400;
      color: rgba(34, 34, 34, 1);
      background: rgba(243, 245, 249, 1);
      margin-right: 12px;
      padding-left: 6px;
      padding-right: 6px;
      text-align: center;
      border: none;
      &:last-child {
        margin-right: 0;
      }
    }
    .btn-customer {
      flex-grow: 0;
      width: 80px;
    }

    .btn-subscribe {
      flex-grow: 1;
      color: #ffffff;
      background: linear-gradient(
        -51deg,
        rgba(255, 68, 68, 1) 0%,
        rgba(255, 50, 93, 1) 100%
      );
    }
    .s-vip{
      flex-grow: 1;
      background: #FED690;
      display: flex;
      flex-direction: column;
      align-items: center;
      line-height: unset;
      .s-vip-t{
        font-size: 16px;
        color: #72391C;
        font-weight: 700;
      }
      .s-vip-tip{
        font-size: 14px;
        color: #813824;
        font-weight: 400;
      }

    }
    .btn-buy {
      flex-grow: 1;
      color: #ffffff;
      background: linear-gradient(
        -51deg,
        rgba(255, 68, 68, 1) 0%,
        rgba(255, 50, 93, 1) 100%
      );
      align-items: center;
      display: flex;
      del {
        font-size: 12px;
        margin-left: 4px;
      }
    }
  }
  .group-vanbtn {
    flex: 1;
    height: 40px;
    background: linear-gradient(
            -58deg,
            rgba(255, 102, 102, 1) 0%,
            rgba(255, 68, 68, 1) 100%
    );
    border-radius: 20px;
    font-size: 14px;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    line-height: 0;

    span {
      margin-top: 2px;
    }

    .deltip {
      display: block;
      font-size: 10px;
      font-weight: normal;
      margin-top: 16px;
    }
  }
}

.h5-audition {
  width: 70px;
  height: 84px;
  z-index: 40;
  position: fixed;
  right: 20px;
  bottom: 60px;
}
.h5-audition-bottom {
  bottom: 100px !important;
}

@keyframes scaleAnimation {
  from {
    transform: scale(0.9);
  }
  to {
    transform: scale(1.1);
  }
}
.scale-animation {
  animation: scaleAnimation 0.4s linear infinite alternate;
}
</style>
<style lang="scss">
.course-details {
  .rich-text {
    p {
      margin: 10px 0;
    }
    video {
      width: 100%;
      max-width: 100%;
    }
  }
}

video::-internal-media-controls-download-button {
  display: none;
}
video::-webkit-media-controls-enclosure {
  overflow: hidden;
}
video::-webkit-media-controls-panel {
  width: calc(100% + 30px);
}
</style>
